import './assets/css/App.css';
import './assets/css/NotionStyle.css';
import { Routes, Route, Navigate } from 'react-router-dom';
import {} from 'react-router-dom';
import AuthLayout from './layouts/auth';
import AdminLayout from './layouts/admin';
import RTLLayout from './layouts/rtl';
import StandaloneLayout from './layouts/standalone';
import OAuthCallback from './views/oauth/Callback';
import {
  ChakraProvider,
  // extendTheme
} from '@chakra-ui/react';
import initialTheme from './theme/theme'; //  { themeGreen }
import PrivateRoute from './components/PrivateRoute';
import { useState } from 'react';
import { OnboardingProvider } from './contexts/OnboardingContext';
import { GuestProvider } from './contexts/GuestContext';
import { TeamProvider } from './contexts/TeamContext';
// Chakra imports

export default function Main() {
  // eslint-disable-next-line
  const [currentTheme, setCurrentTheme] = useState(initialTheme);
  return (
    <ChakraProvider theme={currentTheme}>
      <GuestProvider>
        <TeamProvider>
          <OnboardingProvider>
          <Routes>
            <Route path="auth/*" element={<AuthLayout />} />
            {/* Public route - allows guest access */}
            <Route
              path="meetings/*"
              element={<StandaloneLayout theme={currentTheme} setTheme={setCurrentTheme} />}
            />
            <Route
              path="admin/*"
              element={
                <PrivateRoute><AdminLayout theme={currentTheme} setTheme={setCurrentTheme} /></PrivateRoute>
              }
            />
            <Route
              path="rtl/*"
              element={
                <RTLLayout theme={currentTheme} setTheme={setCurrentTheme} />
              }
            />
            <Route path="oauth/:platformId/callback" element={<OAuthCallback />} />
            <Route path="integrations/:platformId/create" element={<OAuthCallback />} />
            <Route path="/" element={<Navigate to="/admin" replace />} />
          </Routes>
        </OnboardingProvider>
        </TeamProvider>
      </GuestProvider>
    </ChakraProvider>
  );
}
